// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cN","homeContent__bottom":"c-i_cO","homeContent__cardHolder":"c-i_cP","homeContent__seoTextHolder":"c-i_cQ"};